import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

export const ErrorTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    slotProps={{
      arrow: { sx: { color: 'error.light' } },
      ...props.slotProps,
    }}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: '12px',
    color: theme.vars.palette.error.main,
    backgroundColor: theme.vars.palette.semantic.tint.red.soft,
    borderRadius: '8px',
    borderColor: theme.vars.palette.error.light,
  },
}));
